import { render, staticRenderFns } from "./UpdateMaxHoldLimitPopup.vue?vue&type=template&id=7b885ae5&scoped=true&"
import script from "./UpdateMaxHoldLimitPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateMaxHoldLimitPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateMaxHoldLimitPopup.vue?vue&type=style&index=0&id=7b885ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b885ae5",
  null
  
)

export default component.exports